import { noteSchema } from './baseNoteSchema';
export * from './baseNoteSchema';
export * from './careNavigatorUnscheduledNote';
export * from './cnAppointmentNoteSchema';
export * from './couplesFamilyNoteSchema';
export * from './intakeFollowUpNoteSchema';
export * from './lateCancelNoteSchema';
export * from './legacyNoteSchema';
export * from './minorNoteSchema';
export * from './notAttendedNoteSchema';
export * from './noteSchemaInstance';
export * from './providerUnscheduledNoteSchema';
export * from './adultMedManagementNoteSchema';
export * from './medManagerUnscheduledNoteSchema';
export var isNoShowNote = function (note) {
    return (note === null || note === void 0 ? void 0 : note.noteSchema) === noteSchema.lateCancel || (note === null || note === void 0 ? void 0 : note.noteSchema) === noteSchema.notAttended;
};
